import moment from "moment-timezone";
import { getRecoil } from "recoil-nexus";
import { authState, currentStoreState } from "../recoil/auth";
import Axios, { Response } from "../utils/Axios";

// print: {
//     path: 발생경로,
//     params: 프린트 출력 트리거,
//     params2: order_id,
// }

// click: {
//     path: 발생경로,
//     params: 클릭 버튼,
//     params2: order_id,
// }

// delivery: {
//     path: 발생경로,
//     params: 배달 프로그램 / 배달 유형,
//     params2: order_id,
// }

// event: {
//     path: 이벤트 위치,
//     params: 이벤트 종류,
//     params2: order_id,
// }

const LogController = {
  print: async (data: {
    path: string;
    params: string;
    params2: string;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(currentStoreState).value!.store_id,
        action_name: "POS_print",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  click: async (data: {
    path: string;
    params: string;
    params2: string;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(currentStoreState).value!.store_id,
        action_name: "POS_click",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  delivery: async (data: {
    path: string;
    params: string;
    params2: string;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(currentStoreState).value!.store_id,
        action_name: "POS_delivery",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  event: async (data: {
    path: string;
    params: string;
    params2: string;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(currentStoreState).value!.store_id,
        action_name: "POS_event",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default LogController;
